/**
 * Converte uma URL relativa para absoluta
 * @param url URL relativa ou absoluta
 * @returns URL absoluta
 */
export function toAbs(url: string | null | undefined): string {
  if (!url) return '';

  // Já é absoluta
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  // Normaliza para começar com '/'
  const normalizedUrl = url.startsWith('/') ? url : `/${url}`;

  // Se for um asset do front (pasta public), use a própria origem do front
  // Exemplos: /images/..., /favicon.ico, /logo192.png, etc.
  const isFrontendAsset = normalizedUrl.startsWith('/images/')
    || normalizedUrl === '/favicon.ico'
    || normalizedUrl.startsWith('/logo')
    || normalizedUrl.startsWith('/assets/');

  if (isFrontendAsset && typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${normalizedUrl}`;
  }

  // Caso contrário, trate como asset do backend
  const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  const assetBaseUrl = baseUrl.replace('/api/v1', '');
  return `${assetBaseUrl}${normalizedUrl}`;
}

function addCloudinaryOpts(url: string): string {
  const match = url.match(/^(https:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\/)(.+)$/);
  if (!match) return url;
  const [, base, rest] = match;
  if (rest.startsWith('f_') || rest.startsWith('q_') || rest.includes(',f_') || rest.includes(',q_')) return url;
  return `${base}f_auto,q_auto/${rest}`;
}

// Resolve URLs de assets, escolhendo automaticamente a origem correta (frontend x backend)
export function toAsset(url: string | null | undefined): string {
  const resolved = toAbs(url);
  return resolved.includes('res.cloudinary.com') ? addCloudinaryOpts(resolved) : resolved;
}